module.exports = __webpack_public_path__ + "static/media/empty_table.58f2ab03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/admin/empty_table.svg
// module id = 972
// module chunks = 0